import { render, staticRenderFns } from "./icon-chevron-right.vue?vue&type=template&id=7b2e265a&"
import script from "./icon-chevron-right.vue?vue&type=script&lang=js&"
export * from "./icon-chevron-right.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\MidwestBeltone.Iframes.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b2e265a')) {
      api.createRecord('7b2e265a', component.options)
    } else {
      api.reload('7b2e265a', component.options)
    }
    module.hot.accept("./icon-chevron-right.vue?vue&type=template&id=7b2e265a&", function () {
      api.rerender('7b2e265a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Frontend/vue/icons/icon-chevron-right.vue"
export default component.exports